import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { BehaviorSubject, Observable } from "rxjs";
import { AuthResponse } from "../auth.model";
import { environment } from "../../../../environments/environment";
import { registrationActions } from "../../registration/store/actions";
import { authActions } from "../store/actions";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private http: HttpClient, private store: Store) {}

  resetForms: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  resetForms$: Observable<boolean> = this.resetForms.asObservable();

  login(username: string): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(
      `${environment.apiUri}/canvasser/validate`,
      { username: username }
    );
  }

  logout(): void {
    this.store.dispatch(authActions.requestLogout());
    this.store.dispatch(registrationActions.requestFullReset());
  }

  resetFormData() {
    this.resetForms.next(true);
    this.store.dispatch(registrationActions.requestPartialReset());
  }
}
